var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayrollIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.65,18.75c-3.77-1-5-2-5-3.56,0-1.81,1.67-3.07,4.47-3.07,3,0,4,1.41,4.14,3.48H29a6.59,6.59,0,0,0-5.32-6.31V5.66h-5V9.24c-3.21.7-5.8,2.78-5.8,6,0,3.83,3.17,5.74,7.79,6.84,4.14,1,5,2.46,5,4,0,1.14-.81,3-4.47,3-3.41,0-4.76-1.52-4.94-3.48H12.57c.19,3.63,2.91,5.67,6.09,6.35v3.6h5V31.92c3.24-.61,5.8-2.48,5.8-5.88,0-4.7-4-6.31-7.78-7.29",
    style: {
      fill: "#62a3ef"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollIcon);
export default __webpack_public_path__ + "static/media/payroll_icon.8b84938845768895e904d02a05bca767.svg";
export { ForwardRef as ReactComponent };